import AHRISystemToolPaginationCustomState from "@crescentParts/Store/Data/AHRISystemToolPagination/AHRISystemToolPaginationState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState = {
    ahriSystemToolPageNumber:1,
    ahriSystemToolPageSize:9
};
const reducer = {
    "Custom/AHRISystemToolConfigPagination/PageNumber":(draft:Draft<AHRISystemToolPaginationCustomState>,action:{pageNumber:number},)=>{
        draft.ahriSystemToolPageNumber = action.pageNumber
    },
    "Custom/AHRISystemToolConfigPagination/PageSize":(draft:Draft<AHRISystemToolPaginationCustomState>,action:{pageSize:number},)=>{
        draft.ahriSystemToolPageSize = action.pageSize
    },
}

export default createTypedReducerWithImmer(initialState, reducer);